
  var _styles = {
  "card-container": {
    "position": "relative",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "overflow": "visible",
    "width": "21.52rem"
  },
  "card-content": {
    "borderRadius": "0.32rem",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "position": "absolute",
    "width": "100%",
    "height": "100%",
    "top": 0,
    "left": 0
  },
  "flex-center": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center"
  }
};



  module.exports = _styles;
  